import utils from 'utils';
class comprehensiveIncomeTaxCtrl {
  constructor($scope, httpRequest, initSortService, $filter) {
    $scope.params = {
        pageSize: 2000,
        pageNum: 1,
        param: {
          isRoleOwner: '1', // 拥有本机构角色
          orgIdList: [JSON.parse(localStorage.user_info).org.orgId], // 所属机构
        },
      }
    $scope.select = {}
    $scope.treeConfig = {
        isCheckall: true,
        check: {
            //如果没有设置配置项，取默认配置
            enable: true, //显示不显示复选框
            chkboxType: { Y: '', N: '' },
        },
    }
    $scope.currentUserInfo = JSON.parse(localStorage.user_info).user
    $scope.selectedOrgList = [
      {
        orgId: $scope.currentUserInfo.userId,
        orgName: $scope.currentUserInfo.userName + '|' + $scope.currentUserInfo.realName,
        checked: true,
      },
    ]
    $scope.param = {
      pageNum: 1,
      pageSize: 10,
      param: {
        taxNo: '',
        companyName: '',
        accessToken: localStorage.id_token,
        applyPeriod: utils.getLastMonthFirstLast().preMonth, // 时间
        status: '1',
        employeeList: [{employeeName:$scope.currentUserInfo.realName, employeeNumber:$scope.currentUserInfo.userName}]
      },
    };
    $scope.companyNameConfig = [];
    //查询
    function queryInfo() {
      const openLoading =
        $scope.param.pageSize >= 100
          ? window.layer.msg('正在查询，请耐心等待', {
              time: 0,
              skin: 'layer-loading-self',
              icon: 16,
              shade: 0.5,
            })
          : null;
      httpRequest
        .post_getRpaGsResultDtoList(queryDataHandle($scope.param))
        .then((res) => {
          $scope.listData = res.data.value.list;
          $scope.totalItems = res.data.value.total;
          $scope.param.pageNum = ++res.data.value.prePage;
          $scope.param.pageSize = res.data.value.pageSize;
        })
        .finally(() => {
          window.layer.close(openLoading);
        });
    }
    function queryDataHandle(queryData) {
        $scope.employeeList = []
        const { selectedFollower } = $scope.select
        selectedFollower.forEach(item => {
            $scope.employeeList.push({employeeName:item.employeeName, employeeNumber:item.employeeNumber})
        });
        queryData.param.employeeList = $scope.employeeList
        return queryData
    }
    // 改变税款所属月份
    $scope.updateSearch = function () {
      queryInfo();
    };
    //重置
    $scope.reset = function () {
      $scope.param.param = {
        taxNo: '',
        companyName: '',
        applyPeriod: utils.getLastMonthFirstLast().preMonth,
        accessToken: localStorage.id_token,
        status: '1',
      };
      $scope.belleRegionCityList = [];
      getUserInfo()
    };
    // 字典数据
    $scope.dictData = {};
    const typecodeArrStr = '["status","department_no","gs_applyType"]';
    httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
      $scope.dictData = res.data.value;
    });
    // 获取所有主管税局信息
    httpRequest
      .get_getAllTaxBureau(localStorage.getItem('id_token'))
      .then((res) => {
        $scope.dictDataProvince = res.data.value;
      });
    //获取所属大区 获取地区时两个参数都不传，获取管理城市时事业部和地区两个都要传
    httpRequest.get_getBelleRegion().then((res) => {
      $scope.belleRegionList = res.data.value;
    });
    function getUserInfo() {
        httpRequest.get_getIvatEmployeeList().then((res) => {
            $scope.followerList = dataHandle(res.data.value)
            $scope.select.selectedFollower =  $scope.followerList.filter((x) => { return x.employeeName == $scope.currentUserInfo.realName})
            queryInfo()
          })
    }
    getUserInfo()
    function dataHandle(list) {
        list.forEach((el,index) => {
            el.orgId = index
            el.orgName = el.employeeName + '|' + el.employeeNumber
            if ($scope.currentUserInfo.realName == el.employeeName) {
                el.checked = true
            } else {
                el.checked = false
            }
        })
        return list
    }
    // 分页
    $scope.pageChanged = function () {
      queryInfo();
    };
    // 更多条件
    $scope.customizedConfig = {
      version: 1.0,
      queryConfig: [
        {
          label: '纳税人识别号',
          selected: true,
          default: true,
        },
        {
          label: '纳税人名称',
          selected: true,
          default: true,
        },
        {
          label: '启用状态',
          selected: true,
          default: true,
        },
        {
          label: '事业部',
          selected: false,
          default: false,
        },
        {
          label: '所属大区',
          selected: false,
          default: false,
        },
        {
          label: '管理城市',
          selected: false,
          default: false,
        },
        {
          label: '主管税局所在省(市)',
          selected: true,
          default: true,
        },
        {
          label: '申报方案',
          selected: false,
          default: false,
        },
        {
          label: '跟进人',
          selected: false,
          default: false,
        },
      ],
      table: [
        {
          label: '纳税人识别号',
          selected: true,
          default: true,
        },
        {
          label: '纳税人名称',
          selected: true,
          default: true,
        },
        {
          label: '纳税人数',
          selected: true,
          default: true,
        },
        {
          label: '本期收入',
          selected: true,
          default: true,
        },
        {
          label: '累计收入',
          selected: true,
          default: true,
        },
        {
          label: '应扣缴税额',
          selected: true,
          default: true,
        },
        {
          label: '已缴税额',
          selected: true,
          default: true,
        },
        {
          label: '应补（退）税额',
          selected: true,
          default: true,
        },
        {
          label: '启用状态',
          selected: true,
          default: true,
        },
        {
          label: '事业部',
          selected: false,
          default: false,
        },
        {
          label: '所属大区',
          selected: false,
          default: false,
        },
        {
          label: '管理城市',
          selected: false,
          default: false,
        },
        {
          label: '主管税局所在省(市)',
          selected: true,
          default: true,
        },
        {
          label: '申报方案',
          selected: false,
          default: false,
        },
        {
            label: '跟进人',
            selected: false,
            default: false,
        },
      ],
    };
    // 关联查询管理城市
    $scope.linkageQuery = function (enumName) {
      let departmenNoObj = $scope.dictData.department_no.find((v) => {
        return v.enumName === enumName;
      });
      let belleRegionListObj = $scope.belleRegionList.find((v) => {
        return v.regionName === enumName;
      });
      if (departmenNoObj) {
        $scope.departmentNo = departmenNoObj.enumCode;
      }
      if (belleRegionListObj) {
        $scope.regionNo = belleRegionListObj.treeLevelCode;
      }
      let params = {
        affiliation: $scope.departmentNo,
        regionNo: $scope.regionNo,
      };
      if (params.affiliation == '' || params.regionNo == '') return;
      httpRequest.get_getBelleRegion(params).then((res) => {
        $scope.belleRegionCityList = res.data.value;
      });
    };
    // 点击搜索发起查询
    $scope.searchlist = function () {
      queryInfo();
    };
    // 导出
    $scope.exportExelc = function () {
      let fileName =
        '综合所得税申报(个人所得税)_' +
        $scope.param.param.applyPeriod.replace('-', '');
      let _url = `${
        host.etcloudIvatApp
      }taxdeclaration/rpaGsTask/exportList?accessToken=${localStorage.getItem(
        'id_token'
      )}`;
      utils.file_download(
        _url,
        $scope.param.param,
        'gs_result',
        'POST',
        'arraybuffer',
        fileName,
        false
      );
    };
  }
}
comprehensiveIncomeTaxCtrl.$inject = [
  '$scope',
  'httpRequest',
  'initSortService',
  '$filter',
];
export default comprehensiveIncomeTaxCtrl;



// WEBPACK FOOTER //
// ./src/app/declaration/personalIncomeTax/comprehensiveIncomeTax/comprehensiveIncomeTaxCtrl.js